/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import TermsAndConditions from "../_metronic/layout/components/TermsAndConditions";
import PrivayAndPolicy from "../_metronic/layout/components/PrivayAndPolicy";
import AboutUs from "../_metronic/layout/components/AboutUs";
import { LDProvider } from "launchdarkly-react-client-sdk";

export function Routes() {
  const { isAuthorized } = useSelector(
    ({ auth }) => ({
      isAuthorized: auth.user != null,
    }),
    shallowEqual
  );

  const organisationId = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation.id;
    } else {
      return null;
    }
  });

  const context = {
    kind: "user",
    key: String(organisationId),
    custom: {
      organization: String(organisationId),
    },
  };

  return (
    <Switch>
      <Route path="/terms" exact component={TermsAndConditions} />
      <Route path="/privacy" exact component={PrivayAndPolicy} />
      <Route path="/about" exact component={AboutUs} />

      {!isAuthorized ? (
        /*Render auth page when user at `/auth` and not authorized.*/
        <Route>
          <AuthPage />
        </Route>
      ) : (
        /*Otherwise redirect to root page (`/`)*/
        <Redirect from="/auth" to="/locations" />
      )}

      <Route path="/error" component={ErrorsPage} />
      <Route path="/logout" component={Logout} />

      {!isAuthorized /*Redirect to `/auth` when user is not authorized*/ ? (
        <Redirect to="/auth/login" />
      ) : (
        <LDProvider
          clientSideID={process.env.REACT_APP_LD_CLIENT_ID}
          context={context}
        >
          <Layout>
            <BasePage />
          </Layout>
        </LDProvider>
      )}
    </Switch>
  );
}
